// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-form * {
  margin: 0;
  padding: 0;
  outline: none;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.batch-form-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 10px;
}

.batch-form-container {
  max-width: 800px;
  background: linear-gradient(115deg, #f2fdfd 10%, #fff3a8 90%);
  width: 100%;
  padding: 25px 40px 10px 40px;
  box-shadow: 0px 0px 10px rgba(247, 107, 0, 0.1);
}






.batch-form-container .batch-form-text {
  text-align: center;
  font-size: 41px;
  font-weight: 600;
  color: #0e0909;

}
/* .batch-year-title {
  font-size: 1.2em; 
  font-weight: bold; 
  margin-bottom: -4rem; 
} */

.batch-form-container form {
  padding: 30px 0 0 0;
}

.batch-form-container .batch-form-row {
  display: flex;
  margin: 40px 0;
  flex-wrap: wrap;
  
}

.batch-form-input-data {
  flex: 1 1;
  min-width: 220px;
  margin: 0 10px;
  position: relative;
}


.batch-form-input-data input,
.batch-form-textarea textarea {
  display: block;
  width: 100%;
  border: none;
  font-size: 17px;
  border-bottom: 2px solid rgba(17, 16, 16, 0.12);
  margin-bottom: 5px;
  padding-bottom: 10px;
  transition: border-bottom-color 0.3s ease;
}

/* Input error state */
.input-error {
  border-bottom-color: rgb(224, 64, 64) !important;
}


.batch-form-textarea textarea {
  resize: none;
  padding-top: 10px;
}


.batch-form-input-data label {
  position: absolute;
  pointer-events: none;
  bottom: 38px;
  font-size: 18px;
  transition: all 0.3s ease;
  color: rgb(245, 164, 1);
  font-weight: 400;
}
.error {
  position: absolute;
  bottom: -15px; 
  font-size: 12px;
  color: red;
}
.batch-form-submit-btn .batch-form-input-data {
  overflow: hidden;
  height: 45px !important;
  width: 25% !important;
}

.batch-form-input-data select {
  display: block;
  width: 100%;
  height: 40px;
  border: none;
  font-size: 17px;
  border-bottom: 2px solid rgba(27, 25, 25, 0.12);
  background-color: transparent;
  position: relative; 
  z-index: 1;
}



/* 

.batch-form-submit-btn .batch-form-input-data .batch-form-inner {
  height: 100%;
  width: 300%;
  position: absolute;
  left: -100%;
  background: -webkit-linear-gradient(right, #b08e49, #da7115, #e6e941, #f18509);
  transition: all 0.4s;
}

.batch-form-submit-btn .batch-form-input-data:hover .batch-form-inner {
  left: 0;
}

.batch-form-submit-btn .batch-form-input-data input {
  background: none;
  border:none;
  color: #0e0909;
  font-size: 17px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding:10px;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
 */

/* ////calendar design//// */

/* DatePickerStyles.css */

.react-datepicker {
  background-color: #d0885e !important; /* Solid background color */
  border: 1px solid #ccc !important;   /* Optional: Add a border */

}
.datePickerParent{
position: absolute;
z-index: 1000;

}
.react-datepicker__header {
  background-color: #d38f3b !important; /* Header background color */
  color: white !important; /* Header text color */
}

.react-datepicker__day--selected,
.react-datepicker__day:hover {
  background-color: #eba52d !important; /* Selected day background color */
  color: white !important; /* Selected day text color */
}

.react-datepicker__day {
  color: #333 !important; /* Default day text color */
}

.react-datepicker__triangle {
  display: none !important; /* Optional: Hide the triangle indicator */
}





@media (max-width: 710px) {
  .batch-form-row {
    display: block; /* Stack elements vertically */
  }

  .batch-form-input-data {
    margin-right: 0;
    margin-bottom: 50px;

  }

  .batch-form-text {
    font-size: 20px; /* Slightly smaller font size */
  }
  .batch-form-input-data1 label {
    font-size: 12px; /* Smaller label font */
  }

  .batch-form-input-data input,
  .batch-form-input-data select,
  .batch-form-textarea textarea {
    font-size: 15px; /* Adjust input field font size */
  }
  .batch-form-input-data label {
    font-size: 12px; /* Smaller label font */
  }

  .batch-form-input-data input,
  .batch-form-input-data select,
  .batch-form-textarea textarea {
    font-size: 15px; /* Adjust input field font size */
  }

  .batch-form-submit-btn input[type="submit"] {
    font-size: 14px;
    padding: 8px 16px; /* Adjust submit button padding */
  }
  
  .batch-form-row {
    display: flex;
    flex-direction: column;
    gap: 50px; /* Adjust the gap size as needed */
  }

  .batch-form-input-data {
    width: 100%;
    margin-bottom: 10px; /* You can adjust the margin for extra spacing */
  }
}

/* Additional small-screen adjustments (optional) */
@media (max-width: 400px) {
  .batch-form-text {
    font-size: 18px; /* Further reduce font size */
  }

  .batch-form-input-data input,
  .batch-form-input-data select,
  .batch-form-textarea textarea {
    font-size: 14px;
  }

  .batch-form-submit-btn input[type="submit"] {
    font-size: 12px;
    padding: 6px 12px;
  }

}




`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/BatchForm.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,WAAW;EACX,4BAA4B;EAC5B,+CAA+C;AACjD;;;;;;;AAOA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;;AAEhB;AACA;;;;GAIG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;;AAGA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;AAClD;;;AAGA;EACE,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE;;AAEF,4BAA4B;;AAE5B,yBAAyB;;AAEzB;EACE,oCAAoC,EAAE,2BAA2B;EACjE,iCAAiC,IAAI,2BAA2B;;AAElE;AACA;AACA,kBAAkB;AAClB,aAAa;;AAEb;AACA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,uBAAuB,EAAE,sBAAsB;AACjD;;AAEA;;EAEE,oCAAoC,EAAE,kCAAkC;EACxE,uBAAuB,EAAE,4BAA4B;AACvD;;AAEA;EACE,sBAAsB,EAAE,2BAA2B;AACrD;;AAEA;EACE,wBAAwB,EAAE,0CAA0C;AACtE;;;;;;AAMA;EACE;IACE,cAAc,EAAE,8BAA8B;EAChD;;EAEA;IACE,eAAe;IACf,mBAAmB;;EAErB;;EAEA;IACE,eAAe,EAAE,+BAA+B;EAClD;EACA;IACE,eAAe,EAAE,uBAAuB;EAC1C;;EAEA;;;IAGE,eAAe,EAAE,iCAAiC;EACpD;EACA;IACE,eAAe,EAAE,uBAAuB;EAC1C;;EAEA;;;IAGE,eAAe,EAAE,iCAAiC;EACpD;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,iCAAiC;EACtD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,kCAAkC;EAC/C;;EAEA;IACE,WAAW;IACX,mBAAmB,EAAE,gDAAgD;EACvE;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,eAAe,EAAE,6BAA6B;EAChD;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap');\r\n\r\n.batch-form * {\r\n  margin: 0;\r\n  padding: 0;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n.batch-form-body {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  padding: 10px;\r\n}\r\n\r\n.batch-form-container {\r\n  max-width: 800px;\r\n  background: linear-gradient(115deg, #f2fdfd 10%, #fff3a8 90%);\r\n  width: 100%;\r\n  padding: 25px 40px 10px 40px;\r\n  box-shadow: 0px 0px 10px rgba(247, 107, 0, 0.1);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.batch-form-container .batch-form-text {\r\n  text-align: center;\r\n  font-size: 41px;\r\n  font-weight: 600;\r\n  color: #0e0909;\r\n\r\n}\r\n/* .batch-year-title {\r\n  font-size: 1.2em; \r\n  font-weight: bold; \r\n  margin-bottom: -4rem; \r\n} */\r\n\r\n.batch-form-container form {\r\n  padding: 30px 0 0 0;\r\n}\r\n\r\n.batch-form-container .batch-form-row {\r\n  display: flex;\r\n  margin: 40px 0;\r\n  flex-wrap: wrap;\r\n  \r\n}\r\n\r\n.batch-form-input-data {\r\n  flex: 1;\r\n  min-width: 220px;\r\n  margin: 0 10px;\r\n  position: relative;\r\n}\r\n\r\n\r\n.batch-form-input-data input,\r\n.batch-form-textarea textarea {\r\n  display: block;\r\n  width: 100%;\r\n  border: none;\r\n  font-size: 17px;\r\n  border-bottom: 2px solid rgba(17, 16, 16, 0.12);\r\n  margin-bottom: 5px;\r\n  padding-bottom: 10px;\r\n  transition: border-bottom-color 0.3s ease;\r\n}\r\n\r\n/* Input error state */\r\n.input-error {\r\n  border-bottom-color: rgb(224, 64, 64) !important;\r\n}\r\n\r\n\r\n.batch-form-textarea textarea {\r\n  resize: none;\r\n  padding-top: 10px;\r\n}\r\n\r\n\r\n.batch-form-input-data label {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  bottom: 38px;\r\n  font-size: 18px;\r\n  transition: all 0.3s ease;\r\n  color: rgb(245, 164, 1);\r\n  font-weight: 400;\r\n}\r\n.error {\r\n  position: absolute;\r\n  bottom: -15px; \r\n  font-size: 12px;\r\n  color: red;\r\n}\r\n.batch-form-submit-btn .batch-form-input-data {\r\n  overflow: hidden;\r\n  height: 45px !important;\r\n  width: 25% !important;\r\n}\r\n\r\n.batch-form-input-data select {\r\n  display: block;\r\n  width: 100%;\r\n  height: 40px;\r\n  border: none;\r\n  font-size: 17px;\r\n  border-bottom: 2px solid rgba(27, 25, 25, 0.12);\r\n  background-color: transparent;\r\n  position: relative; \r\n  z-index: 1;\r\n}\r\n\r\n\r\n\r\n/* \r\n\r\n.batch-form-submit-btn .batch-form-input-data .batch-form-inner {\r\n  height: 100%;\r\n  width: 300%;\r\n  position: absolute;\r\n  left: -100%;\r\n  background: -webkit-linear-gradient(right, #b08e49, #da7115, #e6e941, #f18509);\r\n  transition: all 0.4s;\r\n}\r\n\r\n.batch-form-submit-btn .batch-form-input-data:hover .batch-form-inner {\r\n  left: 0;\r\n}\r\n\r\n.batch-form-submit-btn .batch-form-input-data input {\r\n  background: none;\r\n  border:none;\r\n  color: #0e0909;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 2px;\r\n  padding:10px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n */\r\n\r\n/* ////calendar design//// */\r\n\r\n/* DatePickerStyles.css */\r\n\r\n.react-datepicker {\r\n  background-color: #d0885e !important; /* Solid background color */\r\n  border: 1px solid #ccc !important;   /* Optional: Add a border */\r\n\r\n}\r\n.datePickerParent{\r\nposition: absolute;\r\nz-index: 1000;\r\n\r\n}\r\n.react-datepicker__header {\r\n  background-color: #d38f3b !important; /* Header background color */\r\n  color: white !important; /* Header text color */\r\n}\r\n\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day:hover {\r\n  background-color: #eba52d !important; /* Selected day background color */\r\n  color: white !important; /* Selected day text color */\r\n}\r\n\r\n.react-datepicker__day {\r\n  color: #333 !important; /* Default day text color */\r\n}\r\n\r\n.react-datepicker__triangle {\r\n  display: none !important; /* Optional: Hide the triangle indicator */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n@media (max-width: 710px) {\r\n  .batch-form-row {\r\n    display: block; /* Stack elements vertically */\r\n  }\r\n\r\n  .batch-form-input-data {\r\n    margin-right: 0;\r\n    margin-bottom: 50px;\r\n\r\n  }\r\n\r\n  .batch-form-text {\r\n    font-size: 20px; /* Slightly smaller font size */\r\n  }\r\n  .batch-form-input-data1 label {\r\n    font-size: 12px; /* Smaller label font */\r\n  }\r\n\r\n  .batch-form-input-data input,\r\n  .batch-form-input-data select,\r\n  .batch-form-textarea textarea {\r\n    font-size: 15px; /* Adjust input field font size */\r\n  }\r\n  .batch-form-input-data label {\r\n    font-size: 12px; /* Smaller label font */\r\n  }\r\n\r\n  .batch-form-input-data input,\r\n  .batch-form-input-data select,\r\n  .batch-form-textarea textarea {\r\n    font-size: 15px; /* Adjust input field font size */\r\n  }\r\n\r\n  .batch-form-submit-btn input[type=\"submit\"] {\r\n    font-size: 14px;\r\n    padding: 8px 16px; /* Adjust submit button padding */\r\n  }\r\n  \r\n  .batch-form-row {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 50px; /* Adjust the gap size as needed */\r\n  }\r\n\r\n  .batch-form-input-data {\r\n    width: 100%;\r\n    margin-bottom: 10px; /* You can adjust the margin for extra spacing */\r\n  }\r\n}\r\n\r\n/* Additional small-screen adjustments (optional) */\r\n@media (max-width: 400px) {\r\n  .batch-form-text {\r\n    font-size: 18px; /* Further reduce font size */\r\n  }\r\n\r\n  .batch-form-input-data input,\r\n  .batch-form-input-data select,\r\n  .batch-form-textarea textarea {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .batch-form-submit-btn input[type=\"submit\"] {\r\n    font-size: 12px;\r\n    padding: 6px 12px;\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
